import api from '../api'
import moment from 'moment'
import io from '../socketio';

const initialState = { obj: null };

export const superChallenge = {
    namespaced: true,
    state: initialState,
    actions: {

        getChallenge({ commit }, cache){
            // if((cache == undefined || cache == true) && this.state.superChallenge.data != null) 
            //     return Promise.resolve(this.state.superChallenge.data);
            
            return api.superChallenge().then(function (response) {
                    commit('getChallenge', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(function (error) {
                    if(error.response.status != 404) api.baseErrorHendler(error);
                    commit('getChallengeFailure');
                    return Promise.reject(error);
                });
        },

        setChallenge({ commit }, sc){
            // console.log("SET QUIZ");
            // console.log(quiz);
            commit('getChallenge', sc);
            return Promise.resolve(sc);
        },
    },
    mutations: {
        getChallengeFailure(state) {
            state.obj = null;
        },
        getChallenge(state, sc) {
            sc.startDate = moment.utc(sc.startDate);

            // leave room when is connected for other quizes
            if(state.obj != null && state.obj.id != sc.id) {
                io.io.emit('leave', { room: "super-challenge:" + state.obj.id });
            }

            // join room
            if(state.obj == null || state.obj.id != sc.id)
                io.io.emit('join', { room: "super-challenge:" + sc.id });

            // don't lose userParticipationStatus
            if(state.obj != null && state.obj.id == sc.id && sc.userApplied == undefined) 
                sc.userApplied = state.obj.userApplied;

            state.obj = sc;
        },
    }
};